import { InvoiceBase } from "../../types/invoice";
import {
    TransactionMatch,
    TransactionMatchBase,
} from "../../types/transactionMatch";
import { valueOrUndefined } from "../dto-helpers";
import { FinancialDocumentDto } from "../financialDocument/financial-document.dto";
import { TransactionMatchFinancialTransactionDto } from "./transaction-match-financial-transaction.dto";

/**
 * Input type for TransactionMatchDto constructor.
 *
 * Uses Base type to accept both Entity types and strict types.
 */
export type TransactionMatchDtoInput = TransactionMatchBase;

export class TransactionMatchDto {
    static deserialize(dto: TransactionMatchDto): TransactionMatch {
        return {
            ...dto,
            financialDocument: dto.financialDocument
                ? FinancialDocumentDto.deserialize(dto.financialDocument)
                : undefined,
            financialTransaction: valueOrUndefined(
                dto.financialTransaction,
                TransactionMatchFinancialTransactionDto.deserialize,
            ),
            // Invoice is passed through; casting needed since InvoiceBase is compatible
            invoice: dto.invoice as TransactionMatch["invoice"],
        };
    }

    id: number;
    financialTransaction?: TransactionMatchFinancialTransactionDto;
    financialDocument?: FinancialDocumentDto;
    invoice?: InvoiceBase;

    constructor(transactionMatch: TransactionMatchDtoInput) {
        this.id = transactionMatch.id;
        this.financialTransaction = valueOrUndefined(
            transactionMatch.financialTransaction,
            (v) => new TransactionMatchFinancialTransactionDto(v),
        );
        this.financialDocument = transactionMatch.financialDocument
            ? new FinancialDocumentDto(transactionMatch.financialDocument)
            : undefined;
        this.invoice = transactionMatch.invoice;
    }
}
